export interface IEnableSpecifiable {
  isEnable: boolean;
}

export function instanceOfIEnableSpecifiable(instance: any): instance is IEnableSpecifiable {
  return instance
    && (instance.isEnable !== undefined);
}
